import { faSave } from '@fortawesome/pro-regular-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { FormikErrors, useFormik } from 'formik';
import React, { useEffect } from 'react';
import VoxelAutocompleteCurrency from '../../../components/muiLegacy/Autocomplete/VoxelAutocompleteCurrency';
import VoxelFormPanel from '../../../components/voxel/Surfaces/VoxelFormPanel/VoxelFormPanel';
import VoxelFormPanelActionSubmit from '../../../components/voxel/Surfaces/VoxelFormPanel/VoxelFormPanelActionSubmit';
import VoxelPanelActions from '../../../components/voxel/Surfaces/VoxelFormPanel/VoxelPanelActions';
import { CurrencyOptionGq } from '../../../graphql/projects/models/CurrencyOptionGq';
import { CurrentUserGq } from '../../../graphql/users/models/CurrentUserGq';
import { usersApiService } from '../../../graphql/users/usersApiService';
import { useUserDefaults } from '../../../logic/otherUtilities/useUserDefaults';
import VoxelFormPanelContent from '../../../components/voxel/Surfaces/VoxelFormPanel/VoxelFormPanelContent';

export interface FormState {
  currency: CurrencyOptionGq;
}

export interface UserCurrencyFormProps {
  user: CurrentUserGq;
  setDirty: (dirty: boolean) => void;
  setSave: (saveFunction: () => Promise<unknown>) => void;
  reload: () => Promise<unknown>;
}

const UserCurrencyForm: React.FC<UserCurrencyFormProps> = ({
  user,
  setDirty,
  setSave,
  reload,
}) => {

  const defaults = useUserDefaults(user);
  const mutation = usersApiService.mutations.useUpdateUserCurrency();
  const formikProps = useFormik<FormState>({
    initialValues: {
      currency: defaults.currency,
    },
    enableReinitialize: true,
    validateOnChange: true,
    validate: (values) => {
      const errors: FormikErrors<FormState> = {};
      return errors;
    },
    onSubmit: (values, actions) =>
      mutation({ currency: values.currency.code ?? null })
        .catch((error) => console.log(error))
        .then(() => reload()),
  });

  useEffect(() => setSave(formikProps.submitForm), [formikProps.submitForm]);
  useEffect(() => {
    setDirty(formikProps.dirty);
    return () => setDirty(false);
  }, [formikProps.dirty]);

  return (
    <VoxelFormPanel
      title={<span>Currency</span>}
      subtitle={
        <span>Default currency setting used to display monetary values in tables and charts.</span>
      }>
      <VoxelFormPanelContent>
        <VoxelAutocompleteCurrency
          labelPosition="top"
          selectedCurrency={formikProps.values?.currency}
          setSelectedCurrency={(option) => formikProps.setFieldValue('currency', option)}
          disabled={formikProps.isSubmitting}
        />
      </VoxelFormPanelContent>
      <VoxelPanelActions>
        <VoxelFormPanelActionSubmit
          title={'Save changes'}
          onClick={formikProps.submitForm}
          disabled={
            formikProps.isSubmitting || !formikProps.isValid || !formikProps.dirty
          }
          endIcon={<FontAwesomeIcon icon={faSave} />}
        />
      </VoxelPanelActions>
    </VoxelFormPanel>
  );
};

export default UserCurrencyForm;
